import { List, Map } from 'immutable'
import { handleActions } from 'redux-actions'
import * as actions from './actions'
import { Gallery } from 'store/records/gallery'
import { ADMIN_WELCOME_EMAIL } from 'store/entities/adminWelcomeEmail/actionTypes'

const handlePending = (state, { payload }) => {
  return state.set('pending', payload.pending)
}

const handleGalleryImages = state => {
  return state.set('pending', true)
}

const handleGalleryImagesSuccess = (state, { payload }) => {
  const galleryImages = payload.data.reduce((images, item) => {
    return images.push(
      Map({
        id: item.id,
        url: item.url,
        ext: item.fileType,
        mime: item.fileType === 'png' ? 'image/png' : 'image/jpeg',
        fileName: item.fileName,
        usagePlaces: item.usagePlaces,
      })
    )
  }, List())
  return state
    .set('images', galleryImages)
    .set('pending', false)
    .set('loaded', true)
}

const handleGalleryImagesFail = state => {
  return state.set('pending', false)
}

const handleAddImageToGallery = (state, { payload }) => {
  const splitLength = payload.url.split(`/`).length
  const imageName = payload.url.split(`/`)[splitLength - 1].split('.')[0]
  if (payload.isConfirmRewriteImage) {
    const oldImage = state.get('images').find(image => image.get('fileName') === imageName)
    const indexForDelete = state.get('images').findIndex(image => image.get('fileName') === imageName)
    const newImages = state
      .get('images')
      .delete(indexForDelete)
      .unshift(Map({ url: payload.url, id: Date.now(), fileName: imageName, usagePlaces: oldImage.get('usagePlaces') }))
    return state.set('images', newImages).set('selected', payload.url)
  }
  return state
    .set(
      'images',
      state.get('images').unshift(Map({ url: payload.url, id: Date.now(), fileName: imageName, usagePlaces: '' }))
    )
    .set('selected', payload.url)
}

const handleResetLoaded = state => {
  return state.set('loaded', false).set('images', List())
}

const handleAdminWelcomeEmailSuccess = (state, { payload }) => {
  return payload.data ? state.set('selected', payload.data.quoteImage) : state
}

const handleSetImageToDelete = (state, { payload }) => {
  return state.set('imageToDelete', payload.url)
}

const handleDeleteImageFromGallery = state => {
  const indexForDelete = state.get('images').findIndex(image => image.get('url') === state.get('imageToDelete'))
  return state
    .deleteIn(['images', indexForDelete])
    .set('imageToDelete', null)
    .set('selected', null)
}

const handleSetSearchBy = (state, { payload }) => {
  return state.set('search', payload.by)
}

const handleSetIsImageNameExist = (state, { payload }) => {
  return state.set('isImageNameExist', payload.value)
}

const handleSetIsButtonDisable = (state, { payload }) => {
  return state.set('isButtonDisable', payload.value)
}

const handleUpdateImageUsagePlaces = (state, { payload: { imagePath, usagePlaces } }) => {
  const indexForUpdate = state.get('images').findIndex(image => image.get('url') === imagePath)
  const existImage = state.get('images').find(image => image.get('url') === imagePath)
  const existUsagePlaces = existImage.get('usagePlaces')
  return state.setIn(['images', indexForUpdate, 'usagePlaces'], existUsagePlaces + usagePlaces)
}

export default handleActions(
  {
    [actions.setPending]: handlePending,
    [actions.addImageToGallery]: handleAddImageToGallery,
    [actions.resetLoaded]: handleResetLoaded,
    [actions.fetchGalleryImages]: handleGalleryImages,
    [actions.fetchGalleryImages.success]: handleGalleryImagesSuccess,
    [actions.fetchGalleryImages.fail]: handleGalleryImagesFail,
    [actions.setSearchBy]: handleSetSearchBy,
    [ADMIN_WELCOME_EMAIL.GET.SUCCESS]: handleAdminWelcomeEmailSuccess,
    [actions.deleteImageFromGallery.success]: handleDeleteImageFromGallery,
    [actions.setImageToDelete]: handleSetImageToDelete,
    [actions.setIsImageNameExist]: handleSetIsImageNameExist,
    [actions.setIsButtonDisable]: handleSetIsButtonDisable,
    [actions.updateImageUsagePlaces]: handleUpdateImageUsagePlaces,
  },
  new Gallery()
)
